import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../components/ui/dialog';
import { Package2, Download, Loader2, CheckCircle2 } from 'lucide-react';
import api from '../../lib/api';
import { toast } from 'sonner';

export function ClosingPackButton({ filters }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const periodLabel = (() => {
    const map = {
      this_month: 'Bulan Ini', last_month: 'Bulan Lalu',
      this_quarter: 'Triwulan Ini', this_year: 'Tahun Ini',
      month: 'Bulan Tertentu', quarter: 'Triwulan Tertentu',
      custom: 'Custom Range',
    };
    return map[filters?.period] || filters?.period || 'Bulan Ini';
  })();

  const download = async () => {
    setBusy(true);
    try {
      const params = { ...filters };
      const res = await api.get('/reports/v2/closing-pack', { params, responseType: 'blob' });
      const blob = new Blob([res.data], { type: 'application/zip' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `closing-pack-${new Date().toISOString().slice(0, 10)}.zip`;
      document.body.appendChild(a); a.click();
      URL.revokeObjectURL(a.href); a.remove();
      toast.success('Monthly Closing Pack berhasil diunduh');
      setOpen(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Gagal mengunduh closing pack');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button
        size="sm" onClick={() => setOpen(true)}
        className="bg-emerald-500 hover:bg-emerald-600 text-white"
        data-testid="reports-closing-pack-btn"
      >
        <Package2 className="h-3.5 w-3.5 mr-1.5" /> Monthly Closing Pack
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="closing-pack-dialog" className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Package2 className="h-5 w-5 text-emerald-400" /> Monthly Closing Pack
            </DialogTitle>
            <DialogDescription>
              Unduh paket laporan lengkap untuk periode <b>{periodLabel}</b> dalam satu file ZIP.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3 text-sm text-slate-200">
            <div className="rounded-lg border border-border bg-card/40 p-3 space-y-1.5">
              <p className="font-medium text-slate-100 flex items-center gap-2"><CheckCircle2 className="h-3.5 w-3.5 text-emerald-400" /> Isi paket:</p>
              <ul className="text-xs text-slate-300 space-y-0.5 pl-5 list-disc">
                <li>11 file Excel: Ringkasan, Invoice, Pembayaran, Piutang, Overdue, Lunas, Pajak, Audit, Penawaran, Client, Produk & Paket</li>
                <li>2 file PDF: Ringkasan & Pajak</li>
                <li>README.txt dengan info periode & filter</li>
              </ul>
            </div>
            <p className="text-xs text-slate-400 italic">Filter aktif saat ini akan diterapkan ke semua laporan dalam paket.</p>
          </div>
          <DialogFooter className="sm:justify-end gap-2">
            <Button variant="ghost" onClick={() => setOpen(false)} disabled={busy}>Batal</Button>
            <Button onClick={download} disabled={busy} data-testid="closing-pack-download" className="bg-emerald-500 hover:bg-emerald-600 text-white">
              {busy ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Membuat ZIP…</> : <><Download className="h-4 w-4 mr-2" /> Download ZIP</>}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
